import { ReactNode } from 'react'
import * as React from 'react'

type Props = {
  children?: ReactNode
  color?: string
  width?: string
  height?: string
  rotate?: string
}

const LinkIcon: React.FunctionComponent<Props> = (props) => {
  const { width, height } = props

  return (
    <svg
      viewBox="0 0 32 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : '100%'}
      height={height ? height : '100%'}
    >
      <path
        d="M27.0769 5.4526C28.3826 5.4526 29.6348 5.96143 30.5581 6.86715C31.4813 7.77287 32 9.00128 32 10.2822V30.8078C32 32.4089 31.3517 33.9444 30.1976 35.0766C29.0435 36.2087 27.4783 36.8447 25.8462 36.8447H11.0769C9.44482 36.8447 7.87957 36.2087 6.7255 35.0766C5.57143 33.9444 4.92308 32.4089 4.92308 30.8078V11.4896C4.92308 9.88845 5.57143 8.35293 6.7255 7.22079C7.87957 6.08864 9.44482 5.4526 11.0769 5.4526H27.0769ZM27.0769 7.86738H11.0769C10.0977 7.86738 9.15851 8.249 8.46607 8.92829C7.77363 9.60758 7.38462 10.5289 7.38462 11.4896V30.8078C7.38462 31.7684 7.77363 32.6898 8.46607 33.369C9.15851 34.0483 10.0977 34.43 11.0769 34.43H25.8462C26.8254 34.43 27.7646 34.0483 28.457 33.369C29.1495 32.6898 29.5385 31.7684 29.5385 30.8078V10.2822C29.5385 9.64172 29.2791 9.02751 28.8175 8.57466C28.3559 8.1218 27.7298 7.86738 27.0769 7.86738ZM23.3846 0.623047V3.03783H9.84615C7.93553 3.03776 6.09925 3.76415 4.72311 5.06439C3.34698 6.36462 2.53811 8.13749 2.46646 10.0105L2.46154 10.2822V25.9782H0V10.2822C2.96722e-05 7.77269 0.995615 5.36174 2.77596 3.55977C4.55631 1.75781 6.98165 0.706297 9.53846 0.627876L9.84615 0.623047H23.3846Z"
        fill="black"
      />
    </svg>
  )
}

export default LinkIcon
